var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76825 1.35077V0.126916C7.76825 0.0208385 7.64634 -0.037742 7.56401 0.0271714L0.426697 5.60181C0.366055 5.64897 0.316986 5.70936 0.283233 5.77837C0.24948 5.84737 0.231934 5.92318 0.231934 6C0.231934 6.07682 0.24948 6.15263 0.283233 6.22163C0.316986 6.29064 0.366055 6.35103 0.426697 6.39819L7.56401 11.9728C7.64792 12.0377 7.76825 11.9792 7.76825 11.8731V10.6492C7.76825 10.5716 7.73184 10.4972 7.67167 10.4497L1.97195 6.00079L7.67167 1.55026C7.73184 1.50276 7.76825 1.42835 7.76825 1.35077Z",
    fill: "white",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/BackArrow.84977d6b506e470e6d751c59c6db46b1.svg";
export { ForwardRef as ReactComponent };